import type { ReactNode } from "react";

type LadderState = "empty" | "stub" | "partial" | "complete" | "validated" | "na";
type VerificationState = "pending" | "verified" | "discrepancy" | "override" | "provisional";
type DispositionState = "landed" | "queued" | "awaiting" | "held";

const ladderLabels: Record<LadderState, string> = {
  empty: "Empty",
  stub: "Stub",
  partial: "Partial",
  complete: "Complete",
  validated: "Validated",
  na: "Not applicable",
};

const verificationLabels: Record<VerificationState, string> = {
  pending: "Pending",
  verified: "Verified",
  discrepancy: "Discrepancy",
  override: "Override",
  provisional: "Provisional",
};

const dispositionLabels: Record<DispositionState, string> = {
  landed: "Landed",
  queued: "Queued",
  awaiting: "Awaiting approval",
  held: "Held",
};

export function LadderPill({ state, label }: { state: LadderState; label?: string }) {
  return <span className={`crmx-pill crmx-pill-ladder is-${state}`}><i className="crmx-pill-swatch" aria-hidden="true" />{label ?? ladderLabels[state]}</span>;
}

export function VerificationPill({ state, label }: { state: VerificationState; label?: string }) {
  return <span className={`crmx-pill crmx-pill-verification is-${state}`}><i className="crmx-pill-ring-dot" aria-hidden="true" />{state === "provisional" && <sup>ᴾ</sup>}{label ?? verificationLabels[state]}</span>;
}

export function DispositionPill({ state, label }: { state: DispositionState; label?: string }) {
  return <span className={`crmx-pill crmx-pill-disposition is-${state}`}><i className="crmx-pill-dot" aria-hidden="true" />{label ?? dispositionLabels[state]}</span>;
}

export function ContextCard({ kicker, title, children }: { kicker: string; title: string; children: ReactNode }) {
  return (
    <section className="crmx-context-card" data-slot="context-card">
      <span>{kicker}</span>
      <strong>{title}</strong>
      <p>{children}</p>
    </section>
  );
}
